import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Landing } from "./pages/Landing/Landing";
import { HomeView } from "./pages/Home/Home";
import { NewCard } from "./pages/NewCard/NewCard";
import { ActionTrackerView } from "./pages/ActionTracker/ActionTracker";
import { ReviewView } from "./pages/ActionTracker/Review";

export default function AppRoutes({ appProps }) {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>
      <Route path="/newcard" element={<NewCard appProps = {appProps} />} />
      <Route path="/newhome" element={<HomeView appProps = {appProps} />} />
      <Route path="/" element={<HomeView appProps = {appProps} />} />
      <Route path="/actiontracker" element={<ActionTrackerView appProps = {appProps} />} />
      <Route path="/review" element={<ReviewView appProps = {appProps} />} />
      <Route path="/landing" element={<Landing appProps = {appProps} />} />
    </Routes>
  );
}


